import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Button,
  Typography,
  Input,
  Icon,
  makeStyles,
  Paper,
  createMuiTheme,
} from "@material-ui/core";

import { Link } from "react-router-dom";
import Axios from "axios";
import SearchAppBar from "./nav/SearchAppBar";
import Loader from "./Loader/Loader";

// import Pagination from "./pagination/Pagination";

// const useStyle = makeStyles({
//   btn: {
//     color: "orangered",
//     fontWeight: "bold",
//     border: "1px solid orangered",
//   },
// });

const MyPokeMon = (obj, PokeMonId) => {
  return (
    <>
      <Grid item lg={3} g md={4} sm={6} xs={12}>
        <Card raised style={{ outline: "none", border: "none" }}>
          <CardActionArea>
            <Typography
              variant="p"
              color="secondary"
              component="span"
              style={{
                position: "absolute",
                fontWeight: "bold",
                margin: "1.2vw 0 0 1.2vw",
                fontSize: "1.1em",
              }}
            >
              {PokeMonId + 1}
            </Typography>
            <CardMedia
              component="img"
              height="250"
              image={`https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${
                PokeMonId + 1
              }.png`}
            ></CardMedia>
            <CardContent>
              <Typography
                variant="h6"
                color="secondary"
                component="h6"
                align="center"
                style={{ textTransform: "uppercase" }}
              >
                {obj.name}
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Link to={`/${PokeMonId + 1}`} style={{ textDecoration: "none" }}>
              <Button size="small" color="secondary" variant="outlined">
                View
              </Button>
            </Link>
            <Button color="secondary" style={{ marginLeft: "auto" }}>
              ♥ ♥ ♥
            </Button>
          </CardActions>
        </Card>
      </Grid>
    </>
  );
};

function PokemonDesk({ darkModeFunc, darkModeVal }) {
  console.log(darkModeFunc, "dark mode");
  // console.log("Re rendering");
  const [query, setQuery] = useState("");
  const [PokApi, setPokApi] = useState([]);
  const [PokeImgLoader, setPokeImgLoader] = useState(false);
  // const [Filter, setFilter] = useState("");

  //these hooks for pagination
  // const [currentPage, setcurrentPage] = useState(1);
  // const [cardPerPage] = useState(80);

  const [MoreCard, setMoreCard] = useState(52);

  // Show More Cards Function
  const showMoreCards = () => {
    setMoreCard((preCards) => preCards + 20);
  };

  useEffect(() => {
    const ApiFunc = async () => {
      const ApiCalling = await Axios.get(
        "https://pokeapi.co/api/v2/pokemon/?limit=895"
      );
      const { data } = ApiCalling;
      console.log(data, "this data check");
      const { results } = data;
      setPokeImgLoader(true);
      setPokApi(results);
    };
    ApiFunc();
  }, []);

  // get-current-card
  // const indexOfLastCard = currentPage * cardPerPage;
  // const indexOfFirstCard = indexOfLastCard - cardPerPage;
  // const currentCards = PokApi.slice(indexOfFirstCard, indexOfLastCard);

  // change page
  // const paginate = (pageNumbers) => setcurrentPage(pageNumbers);

  // Search Or Filter Function

  return (
    <>
      <SearchAppBar
        setValue={setQuery}
        darkModeFunc={darkModeFunc}
        darkModeVal={darkModeVal}
      />

      {!PokeImgLoader ? (
        <Loader />
      ) : (
        <Grid container spacing={4} style={{ padding: "50px", width: "100%" }}>
          {PokApi.slice(0, MoreCard).map(
            (obj, index) =>
              obj.name.toLowerCase().includes(query.toLowerCase()) &&
              MyPokeMon(obj, index)

            // return (
            //   <MyPokeMon key={index} obj={obj} PokeMonId={index} />

            // );
          )}

          <Button
            variant="contained"
            fullWidth
            color="secondary"
            style={{ margin: "3vh 0 0 0" }}
            onClick={showMoreCards}
          >
            Load More
          </Button>
        </Grid>
      )}

      {/* <Pagination
        cardPerPage={cardPerPage}
        totalCards={PokApi.length}
        paginate={paginate}
      /> */}
    </>
  );
}

export default PokemonDesk;
